import CurrencyInput from "react-currency-input-field";
import CurrencySelect from "../CurrencyDropDown/CurrencyDropdwon";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Currency } from "../../../assets/interface/primeSharkWebsite_interface";

interface CurrencyInputInterface {
  value: string;
  setValue: (value: string) => void;
  placeHolder: string;
  id: string;
  prefix?: string;
  suffix?: string;
  maxLength?: number;
  className?:string
}
const CurrencyInputField = ({
  value,
  setValue,
  placeHolder,
  id,
  prefix,
  suffix,
  maxLength,className
}: CurrencyInputInterface) => {
  const selectedCurrency: Currency = useSelector(
    (state: any) => state?.items?.storedPrefferedCurrency
  );
  
  return (
    <div>
      <CurrencyInput
        id={id}
        name="currency"
        placeholder={placeHolder}
        value={value}
        decimalsLimit={2}
        suffix={suffix}
        maxLength={maxLength || undefined}
        prefix={!suffix ? `${selectedCurrency?.symbol ?? "$"} ` : ""}
        onValueChange={(value) => setValue(value || "")}
        className={`form-control ${className}`}
        inputMode="text"

      // style={{  boxShadow: "none" }}
      />
    </div>
  );
};
export default CurrencyInputField;
